jQuery(document).ready(function($) {
  $(".btn-close_menu").click(function(e) {
    $(".mobile_nav").trigger("click");
//     jQuery('.mobilecls').toggleClass('activenew');
//     jQuery('html').removeClass('htmloverflow');
  });
  

//fix sticky header loading on mobile
//too much white margin before load so we just hide the header for a second

  
});
